<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-sitemap"></i> Cargos</h3>
      </div>
    </div>
    <positionAdd v-if="showAdd" ref="positionAdd" v-on:Back="onBack" />
    <positionList v-else ref="positionList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import positionAdd from './components/add/positionAdd.vue'
import positionList from './components/list/positionList.vue'

export default {
  name: 'Position',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    positionAdd,
    positionList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.positionAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/position/position.vue